import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { useAuth, formatApiError } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Connexion reussie");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#081326]">
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 to-slate-950" />
        <div
          className="absolute inset-0 opacity-20"
          style={{ backgroundImage: "url('/login-central.png')", backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="relative text-white">
          <img
            src="/scolaris-logo-light.svg"
            alt="Scolaris Senegalsoft"
            className="block h-auto w-full max-w-[220px]"
        />
        <div className="ml-[66px] mt-1">
            <p className="text-sm font-semibold text-teal-300">Central</p>
            <p className="text-xs text-slate-300">Administration commerciale</p>
        </div>
        </div>
        <div className="relative text-white max-w-md">
          <h1 className="font-display text-4xl font-extrabold leading-tight">
            L'administration commerciale de votre reseau scolaire.
          </h1>
          <p className="mt-4 text-slate-300 leading-relaxed">
            Abonnements, factures annuelles en FCFA, paiements Wave, Orange Money, virement et especes,
            avec validation centralisee et isolation stricte par etablissement.
          </p>
          <div className="mt-8 flex gap-6 text-sm">
            <div><p className="font-mono text-2xl font-bold text-teal-400">4</p><p className="text-slate-400">Groupes scolaires</p></div>
            <div><p className="font-mono text-2xl font-bold text-teal-400">100%</p><p className="text-slate-400">Pistes d'audit</p></div>
            <div><p className="font-mono text-2xl font-bold text-teal-400">FCFA</p><p className="text-slate-400">Multi-paiement</p></div>
          </div>
        </div>
        <p className="relative text-xs text-slate-500">Dakar, Senegal — Administration independante par ecole</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-slate-50">
        <div className="w-full max-w-sm">
        <div className="lg:hidden mb-8 rounded-2xl bg-[#081326] px-4 py-3 text-white shadow-sm">
            <img
              src="/scolaris-logo-light.svg"
              alt="Scolaris Senegalsoft"
              className="block h-auto w-full max-w-[180px]"
            />
            <div className="ml-[54px] mt-1">
              <p className="text-xs font-semibold text-teal-300">Central</p>
              <p className="text-[11px] text-slate-400">Administration commerciale</p>
            </div>
        </div>
          <h2 className="font-display text-2xl font-bold text-slate-900">Connexion</h2>
          <p className="text-sm text-slate-500 mt-1">Accedez a votre espace d'administration.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Adresse email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@scolaris.sn" required className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required className="mt-1.5" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-rose-600">{error}</p>}
            <Button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-teal-600 hover:bg-teal-700 h-11">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Se connecter <ArrowRight className="ml-1.5 h-4 w-4" /></>}
            </Button>
            <div className="text-right">
              <Link to="/forgot-password" data-testid="forgot-link" className="text-sm text-teal-600 hover:underline">Mot de passe oublie ?</Link>
            </div>
          </form>


        </div>
      </div>
    </div>
  );
}
